import { c as _c } from "react/compiler-runtime";
import { DateRangePicker } from '@systemeio/components';
import { LocaleEnum } from '@systemeio/types';
import { ChartBoxSection } from 'modules/main/components/chart-box-section';
import { EventBoxSection } from 'modules/main/components/event-box-section/event-box-section';
import { RevenueLimitNotification } from 'modules/main/components/revenue-limit-notification';
import { MainFilterInterface } from 'modules/main/types/main-filter-interface';
import { FilterHeader } from 'shared/components/filter-header';
import { toFilterGroup, useFilterDraft } from 'shared/hooks/use-filter-draft';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterWithDate } from 'shared/route-query/hooks/use-filter/use-filter-with-date';
import { getDatePickerMinDate } from 'shared/utils/get-date-picker-min-date';
import { getMonthDateRange, getToday } from 'shared/utils/get-dates';
import { twJoin } from 'tailwind-merge';
const defaultFilter: MainFilterInterface = {
  dateSince: null,
  dateTill: null
};
export const Main = () => {
  const $ = _c(51);
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale,
    isFreemium
  } = useUser();
  const {
    filter,
    setFilter,
    defaultFilter: defaults
  } = useFilterWithDate(defaultFilter, getMonthDateRange);
  let t0;
  if ($[0] !== setFilter) {
    t0 = values => setFilter(values);
    $[0] = setFilter;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== defaults || $[3] !== filter || $[4] !== t0) {
    t1 = {
      applied: filter,
      defaults,
      onApply: t0
    };
    $[2] = defaults;
    $[3] = filter;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const state = useFilterDraft(t1);
  let t2;
  if ($[6] !== isFreemium) {
    t2 = isFreemium && <RevenueLimitNotification />;
    $[6] = isFreemium;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("dashboard.main.title");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== intlLocale || $[11] !== state || $[12] !== user?.createdAt || $[13] !== user?.dashboardLocale || $[14] !== user?.timezone) {
    const t5 = user?.timezone;
    let t6;
    if ($[16] !== t5) {
      t6 = getToday(t5);
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    let t7;
    if ($[18] !== user?.timezone) {
      t7 = () => getMonthDateRange(user?.timezone);
      $[18] = user?.timezone;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    let t8;
    if ($[20] !== state.draft.dateSince || $[21] !== state.draft.dateTill) {
      t8 = [state.draft.dateSince, state.draft.dateTill];
      $[20] = state.draft.dateSince;
      $[21] = state.draft.dateTill;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    let t9;
    if ($[23] !== state) {
      t9 = date => {
        const [dateSince, dateTill] = date;
        state.setDraft({
          dateSince,
          dateTill
        });
      };
      $[23] = state;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    const t10 = user?.timezone;
    const t11 = user?.createdAt;
    const t12 = user?.timezone;
    let t13;
    if ($[25] !== t11 || $[26] !== t12) {
      t13 = getDatePickerMinDate(t11, t12);
      $[25] = t11;
      $[26] = t12;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    const t14 = (user?.dashboardLocale === LocaleEnum.PORTUGUESE || user?.dashboardLocale === LocaleEnum.SPANISH) && "tracking-[-0.06em]";
    let t15;
    if ($[28] !== t14) {
      t15 = twJoin(t14);
      $[28] = t14;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    let t16;
    if ($[30] !== intlLocale || $[31] !== t10 || $[32] !== t13 || $[33] !== t15 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
      t16 = <DateRangePicker maxDate={t6} getDefaultDate={t7} date={t8} onChange={t9} timezone={t10} minDate={t13} intlLocale={intlLocale} wrapperButtonInputClassName={t15} />;
      $[30] = intlLocale;
      $[31] = t10;
      $[32] = t13;
      $[33] = t15;
      $[34] = t6;
      $[35] = t7;
      $[36] = t8;
      $[37] = t9;
      $[38] = t16;
    } else {
      t16 = $[38];
    }
    t4 = toFilterGroup(state, [{
      key: "date",
      fields: ["dateSince", "dateTill"],
      node: t16
    }]);
    $[10] = intlLocale;
    $[11] = state;
    $[12] = user?.createdAt;
    $[13] = user?.dashboardLocale;
    $[14] = user?.timezone;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[39] !== t3 || $[40] !== t4) {
    t5 = <FilterHeader title={t3} filters={t4} />;
    $[39] = t3;
    $[40] = t4;
    $[41] = t5;
  } else {
    t5 = $[41];
  }
  let t6;
  if ($[42] !== filter) {
    t6 = <ChartBoxSection filter={filter} />;
    $[42] = filter;
    $[43] = t6;
  } else {
    t6 = $[43];
  }
  let t7;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <EventBoxSection />;
    $[44] = t7;
  } else {
    t7 = $[44];
  }
  let t8;
  if ($[45] !== t6) {
    t8 = <div className="desktop:grid-cols-[minmax(0,1fr)_var(--filter-field-width)] grid gap-5">{t6}{t7}</div>;
    $[45] = t6;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  let t9;
  if ($[47] !== t2 || $[48] !== t5 || $[49] !== t8) {
    t9 = <div className="desktop:[--filter-field-width:310px] mb-[53px] flex flex-col gap-5">{t2}{t5}{t8}</div>;
    $[47] = t2;
    $[48] = t5;
    $[49] = t8;
    $[50] = t9;
  } else {
    t9 = $[50];
  }
  return t9;
};
export default Main;